/* eslint-disable @tencent/tdoc-standalone/no-use-uri-like-literal */
var WENKU_HOST = '//wenku.docs.qq.com';
var DOC_HOST = '//docs.qq.com';
/**
 * host 代理（白名单），因在某些产品域名环境下请求特定接口时，需要挂载到文档域名下发起请求，所以设置一层白名单过滤
 *
 * 目前已有白名单代理:
 *
 * 1、腾讯文库：wenku.docs.qq.com => docs.qq.com
 *
 * @param host 需要代理的域名
 *
 * @returns 代理后的域名
 */
var docHostProxy = function (host) {
    // 腾讯文库
    if (host === WENKU_HOST) {
        return DOC_HOST;
    }
    return host;
};
export default docHostProxy;
